export default "__VITE_ASSET__CE2wwoh8__"